import { fr } from './fr';
import { en } from './en';

export const translations = {
  fr,
  en
};

export const getTranslation = (language, path) => {
  const keys = path.split('.');
  let result = translations[language] || translations.fr;
  
  for (const key of keys) {
    if (result && result[key] !== undefined) {
      result = result[key];
    } else {
      // Fallback to French if key not found
      let fallback = translations.fr;
      for (const k of keys) {
        if (fallback && fallback[k] !== undefined) {
          fallback = fallback[k];
        } else {
          return path; // Return path if not found in fallback
        }
      }
      return fallback;
    }
  }
  
  return result;
};

export { fr, en };
